import { supabase } from './supabase';

export const VAPID_PUBLIC_KEY = 'BEnRhn6rCupEMS3UY_WqbO0STu6HzmsT6q-vXf5KohH6RAUezQ29GueEMNh7VvieNr-sl2Wgp2FMyXJOnZNbpfw';

export const isStandalone = () =>
  (typeof window !== 'undefined') &&
  (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true);

export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
export const pushSupported = () => 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
export const notifPerm = () => (typeof Notification !== 'undefined' ? Notification.permission : 'unsupported');

const b64ToU8 = (b64) => {
  const pad = '='.repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

// Suscribe este dispositivo y guarda la suscripción en el servidor.
export async function subscribePush() {
  if (!pushSupported() || Notification.permission !== 'granted') return false;
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToU8(VAPID_PUBLIC_KEY) });
  const j = sub.toJSON();
  const { error } = await supabase.rpc('save_push_subscription', {
    p_endpoint: j.endpoint, p_p256dh: j.keys.p256dh, p_auth: j.keys.auth, p_ua: navigator.userAgent,
  });
  return !error;
}

export async function reportAppStatus() {
  try {
    await supabase.rpc('report_app_status', {
      p_installed: isStandalone(), p_perm: notifPerm(),
      p_platform: isIOS() ? 'ios' : /android/i.test(navigator.userAgent) ? 'android' : 'otro',
    });
  } catch (e) { /* silencioso */ }
}

export async function listAppStatus() {
  const { data, error } = await supabase.rpc('org_app_status');
  if (error) throw new Error(error.message);
  return Object.fromEntries((data || []).map((r) => [r.user_id, r]));
}
